import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { SuperAdminUser, SuperAdminUserPost } from 'src/types/shared/SuperAdminUser';

export const createSuperAdminUserRequest = createAction('createSuperAdminUserRequest');
export const createSuperAdminUserSuccess = createAction<SuperAdminUserPost>(
    'createSuperAdminUserSuccess',
);
export const createSuperAdminUserFailure = createAction('createSuperAdminUserFailure');

export const createSuperAdminUser = (postbody: SuperAdminUserPost) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(createSuperAdminUserRequest());
    try {
        const { data }: CreateUserResponse = await api.post(`admin/superadmins`, postbody);

        dispatch(createSuperAdminUserSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, createSuperAdminUserFailure, e);
    }
};

interface CreateUserResponse {
    data: SuperAdminUser;
}
